// extracted by mini-css-extract-plugin
export var container = "ProjectContainer-module--container--1-aE6";
export var header = "ProjectContainer-module--header--3lOJu";
export var containerHeader = "ProjectContainer-module--containerHeader--2pYdZ";
export var list = "ProjectContainer-module--list--23tnN";